// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LIYd","field":"styles_field__2vPgV","fieldCol":"styles_fieldCol__2ZtPK","diffCol":"styles_diffCol__34Ddh","diff":"styles_diff__2n26N"};